export default "__VITE_ASSET__82FoTn3v__"